module.exports = __webpack_public_path__ + "img/b4.4b5807d7.png";